import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { animateColorsOnHover, outlineActiveElement } from "ui/styles/style-snippets";

export const ItemListInputWrapper = styled.section`
  position: relative;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: 36px;
  padding-bottom: 4px;
  border-bottom: 1px solid ${(p) => p.theme.borderMediumContrast};

  label {
    margin: 0;
  }
`;

export const ItemCount = styled.span`
  display: block;
  margin: 0 auto 0 8px;
  padding: 0 6px;
  border-radius: 25px;
  background-color: ${(p) => p.theme.bgMediumContrast};
  color: ${(p) => p.theme.textMediumContrast};
  ${Fonts.semiBold_14};
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border: none;
  border-radius: 4px;
  ${Fonts.semiBold_12}
  color: ${(p) => p.theme.textMediumContrast};
  background-color: transparent;
  ${animateColorsOnHover};
  cursor: pointer;

  &:enabled:hover {
    background-color: ${(p) => p.theme.bgApp};
  }
  &:enabled:focus {
    ${outlineActiveElement}
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  & > * {
    width: 100%;
  }
`;

export const FormFooter = styled.footer`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;

  button {
    height: 28px;
    width: 28px;
    padding: 0;

    svg {
      height: 12px;
      width: auto;
    }
  }
`;
